module.exports = __webpack_public_path__ + "img/goal-16.a7d4e60b.png";